import React, { Component } from 'react';
import Page from './page';

class Dashboard extends Component {

    render() {
        return (
            <Page />
        );
    }
}

export default Dashboard;